export default function HTML (pButton)
{
  const baseId = (window.CaaSClientFeatureToggle && window.CaaSClientFeatureToggle.isNotOneForAllHTML) ? pButton.pAttribute.id + '_Dialog' : 'idBEditor_EditHTML_Dialog';

  const configureMonacoEditor = () =>
  {
    window.require.config({ paths: { 'vs': `${bonaPage_StatRes}Common/Editor/MonacoEditor/vs` }});

    window.MonacoEnvironment =
    {
      getWorkerUrl: function(workerId, label)
      {
        return `data:text/javascript;charset=utf-8,${encodeURIComponent(`
          self.MonacoEnvironment =
          {
            baseUrl: '${bonaPage_StatRes}Common/Editor/MonacoEditor/'
          };
          
          importScripts('${bonaPage_StatRes}Common/Editor/MonacoEditor/vs/base/worker/workerMain.js');`
        )}`;
      }
    };
  };


  this.preInitEditHTMLButton = () =>
  {
    const elementBaseId = baseId + '_';

    pButton.pAttribute.Dialog = BEditor.UI.WaWindowManager.createDialog(baseId, pButton.pAttribute.parameters);

    const dialogMainContainer = pButton.pAttribute.Dialog.getMainContainer(),
          dialogMainContainerId = dialogMainContainer.getAttribute('id');

    dialogMainContainer.insertAdjacentHTML('afterbegin', `<style type="text/css">DIV#${dialogMainContainerId}, DIV#${dialogMainContainerId}:before, DIV#${dialogMainContainerId}:after, DIV#${dialogMainContainerId} *:not(.monaco-inputbox) { box-sizing: content-box !important; } DIV#${dialogMainContainerId} A, DIV#${dialogMainContainerId} A:link, DIV#${dialogMainContainerId} A:hover, DIV#${dialogMainContainerId} A:visited { border: none !important; }  DIV#${dialogMainContainerId} A.disabled { border-bottom: 1px solid !important; cursor:default !important; }</style>`);

    pButton.pAttribute.Dialog.setContent(BEditor.UI.EditHTMLDialog.getContentHTML({'elementBaseId': elementBaseId}));
    pButton.pAttribute.Dialog.setFooter(BEditor.UI.EditHTMLDialog.getFooterHTML({'elementBaseId': elementBaseId}));
    pButton.pAttribute.Dialog.setTitle(pButton.pAttribute.parameters.titleText);
    pButton.pAttribute.Dialog.getContentContainer().style.padding = '0px';
    pButton.pAttribute.Dialog.getFooterContainer().style.paddingBottom = '1px';

    const meLoader = BEditor.environment.topWindow.document.createElement('SCRIPT');
    meLoader.type = 'text/javascript';
    meLoader.src = `${bonaPage_StatRes}Common/Editor/MonacoEditor/vs/loader.js`;
    meLoader.addEventListener('load', configureMonacoEditor);
    BEditor.environment.topWindow.document.body.appendChild(meLoader);
    let isEditorLoaded = false;
    let callBack;

    pButton.pAttribute.createMonacoEditor = function (fCallBack)
    {
      pButton.pAttribute.Dialog.setWaitingState();
      isEditorLoaded =false;
      callBack = fCallBack;
      window.require(['vs/editor/editor.main'],createEditor);
      window.setTimeout(ensureEditorLoaded,1000);
    };

    function ensureEditorLoaded()
    {
      if (!isEditorLoaded)
        createEditor();
    }

    function createEditor()
    {
      isEditorLoaded = true;
      pButton.pAttribute.monacoEditor = window.monaco.editor.create(BEditor.domHelpers.$(elementBaseId + 'HTMLCodeContainer'),
      {
        value: '',
        language: 'html',
        wordWrap: 'on'
      });

      pButton.pAttribute.monacoEditor.addAction({
        id: 'pasteWarning',
        label: 'Paste',
        contextMenuGroupId: '9_cutcopypaste',
        run: function() {
          var isMacLike = /(Mac|iPhone|iPad)/i.test(navigator.platform);
          var shortcut = isMacLike ? '\u2318+V' : 'Ctrl+V';
          alert("Your browser can't access the clipboard, so use the " + shortcut + " shortcut");
        }
      });

      var unsupportedActions = ["editor.action.forceRetokenize", "editor.action.inspectTokens", "editor.action.marker.nextInFiles", "editor.action.marker.prevInFiles", "editor.action.sourceAction", "editor.action.showHover", "editor.action.showDefinitionPreviewHover"];

      unsupportedActions.forEach(function (item) 
      {
        var action = pButton.pAttribute.monacoEditor.getAction(item);

        if (action !== null)
        {
          action.isSupported = function() { return false };
        }
      });

      pButton.pAttribute.Dialog.setNormalState();

      if (BEditor.Dialogs['HTML'])
      {
        BEditor.Dialogs['HTML'].monacoEditor = pButton.pAttribute.monacoEditor;
      }

      callBack(pButton.pAttribute.monacoEditor);
    }

    pButton.pAttribute.Dialog.RecalculatedSize.addHandler(function ()
    {
      let container = BEditor.domHelpers.$(elementBaseId + 'HTMLCodeContainer'),
          height = container.parentNode.offsetHeight;

      container.style.height = height + 'px';
    });

    BEditor.Dialogs['HTML'] = { 'id': baseId, 'createMonacoEditor': pButton.pAttribute.createMonacoEditor, 'monacoEditor': pButton.pAttribute.monacoEditor, 'dialog': pButton.pAttribute.Dialog};
  };
}